import { VStack, HStack, Button, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { motion } from "framer-motion";

export const CTASection = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	return (
		<motion.div
			className="w-full"
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			viewport={{ once: true }}
			transition={{ duration: 0.6 }}
		>
			<VStack className="gap-[28px] p-[40px] md:p-[60px] rounded-[16px] bg-gradient-to-r from-pm-strong to-[#FF8C5A]">
				<VStack className="gap-[10px]">
					<h2 className="text-[2rem] md:text-[2.25rem] text-ct-elevated font-semibold text-center">
						{t("home.cta.title")}
					</h2>
					<p className="text-md md:text-lg text-ct-elevated font-medium text-center">
						{t("home.cta.subtitle")}
					</p>
				</VStack>

				<HStack className="gap-[16px] flex-wrap justify-center">
					<Button
						variant="inverted"
						size="lg"
						onClick={() => navigate({ to: "/workflow" })}
						whileHover={{ scale: 1.1 }}
						whileTap={{ scale: 0.95 }}
					>
						<HStack className="gap-[10px]">
							<Icon name="Action" width={24} height={24} />
							<span>{t("home.cta.primary")}</span>
						</HStack>
					</Button>
					<Button
						variant="default"
						size="lg"
						onClick={() => navigate({ to: "/pricing" })}
						whileHover={{ scale: 1.05 }}
					>
						{t("home.cta.secondary")}
					</Button>
				</HStack>
			</VStack>
		</motion.div>
	);
};
